export function _recordInteraction({identifyModule, identifyCode, actionName, actionContent}) {
    this.$store.dispatch('api/post', {
        url: process.env.VUE_APP_EM_ADMIN_URL + "/analytics/log/save/userInteraction",
        data: {
            currentPagePath: this.$route.path,
            identifyModule: identifyModule,
            identifyCode: identifyCode,
            actionName: actionName,
            actionContent: actionContent
        },
        commonErrorHandle: false,
        consoleLog: false
    }).then()
        .finally();
}
